"use client";

import dynamic from "next/dynamic";

export const InlineAgentWrapper = dynamic(() => import("./InlineAgent").then(mod => mod.InlineAgent));
